/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AuditTrailResponse = {
    id: number;
    dateTime: string;
    entityId: number;
    entityType: AuditTrailResponse.entityType;
    collectorId?: number;
    opsUserId?: number;
    opsUserRole?: AuditTrailResponse.opsUserRole;
    eventType: AuditTrailResponse.eventType;
    metadata?: Record<string, string>;
};

export namespace AuditTrailResponse {

    export enum entityType {
        SNAP = 'SNAP',
        OFFER = 'OFFER',
        MATCH = 'MATCH',
        PRODUCT = 'PRODUCT',
        RECEIPT = 'RECEIPT',
    }

    export enum opsUserRole {
        ADMIN = 'ADMIN',
        OPERATOR = 'OPERATOR',
    }

    export enum eventType {
        SNAP_CREATED = 'SNAP_CREATED',
        SNAP_UPDATED = 'SNAP_UPDATED',
        SNAP_FLAGGED_FOR_TROUBLESHOOTING = 'SNAP_FLAGGED_FOR_TROUBLESHOOTING',
        SNAP_UNFLAGGED_FOR_TROUBLESHOOTING = 'SNAP_UNFLAGGED_FOR_TROUBLESHOOTING',
        SNAP_STATE_UPDATED = 'SNAP_STATE_UPDATED',
        SNAP_SENT_TO_MATCHING = 'SNAP_SENT_TO_MATCHING',
        SNAP_OCR_APPROVED = 'SNAP_OCR_APPROVED',
        SNAP_OCR_EDITED = 'SNAP_OCR_EDITED',
        SNAP_ASSIGNED_TO_OPS_USER_FOR_PROCESSING = 'SNAP_ASSIGNED_TO_OPS_USER_FOR_PROCESSING',
        SNAP_PROCESSING_BY_OPS_USER_COMPLETED = 'SNAP_PROCESSING_BY_OPS_USER_COMPLETED',
        SNAP_ESCALATED = 'SNAP_ESCALATED',
        SNAP_DEESCALATED = 'SNAP_DEESCALATED',
        SNAP_SENT_TO_ISSUANCE = 'SNAP_SENT_TO_ISSUANCE',
        SNAP_DEDUPLICATED = 'SNAP_DEDUPLICATED',
        SNAP_DUPLICATE_CONFIRMED = 'SNAP_DUPLICATE_CONFIRMED',
        SNAP_FRAUD_CONFIRMED = 'SNAP_FRAUD_CONFIRMED',
        SNAP_FRAUD_REJECTED = 'SNAP_FRAUD_REJECTED',
        RECEIPT_CREATED = 'RECEIPT_CREATED',
        RECEIPT_CREATED_V2 = 'RECEIPT_CREATED_V2',
        RECEIPT_LINE_ITEM_ADDED = 'RECEIPT_LINE_ITEM_ADDED',
        RECEIPT_LINE_ITEM_ADDED_BATCH = 'RECEIPT_LINE_ITEM_ADDED_BATCH',
        RECEIPT_LINE_ITEM_ADDED_BATCH_V2 = 'RECEIPT_LINE_ITEM_ADDED_BATCH_V2',
        RECEIPT_LINE_ITEM_EDITED = 'RECEIPT_LINE_ITEM_EDITED',
        RECEIPT_LINE_ITEM_DELETED = 'RECEIPT_LINE_ITEM_DELETED',
        RECEIPT_LINE_ITEM_APPROVED = 'RECEIPT_LINE_ITEM_APPROVED',
        SNAP_MATCHING_ADDED = 'SNAP_MATCHING_ADDED',
        SNAP_MATCHING_ADDED_BATCH = 'SNAP_MATCHING_ADDED_BATCH',
        SNAP_MATCHING_EDITED = 'SNAP_MATCHING_EDITED',
        SNAP_MATCHING_APPROVED = 'SNAP_MATCHING_APPROVED',
        SNAP_MATCHING_FLAGGED_TO_DELETE = 'SNAP_MATCHING_FLAGGED_TO_DELETE',
        SNAP_MATCHING_DELETED = 'SNAP_MATCHING_DELETED',
        SNAP_MATCHING_DELETED_BATCH = 'SNAP_MATCHING_DELETED_BATCH',
        SNAP_REMATCH = 'SNAP_REMATCH',
        SNAP_TRANSACTION_SENT_TO_ISSUANCE = 'SNAP_TRANSACTION_SENT_TO_ISSUANCE',
        SNAP_TRANSACTION_BACKED_OUT = 'SNAP_TRANSACTION_BACKED_OUT',
        RETAILER_COMPANY_CREATED = 'RETAILER_COMPANY_CREATED',
        RETAILER_COMPANY_UPDATED = 'RETAILER_COMPANY_UPDATED',
        RETAILER_CREATED = 'RETAILER_CREATED',
        RETAILER_UPDATED = 'RETAILER_UPDATED',
        OFFER_CREATED = 'OFFER_CREATED',
        OFFER_UPDATED = 'OFFER_UPDATED',
        OFFER_ITEM_IDENTITY_UPDATED = 'OFFER_ITEM_IDENTITY_UPDATED',
        PRODUCT_CREATED = 'PRODUCT_CREATED',
        PRODUCT_UPDATED = 'PRODUCT_UPDATED',
        PRODUCT_IDENTITY_UPDATED = 'PRODUCT_IDENTITY_UPDATED',
        PRODUCT_EXCLUSION_UPDATED = 'PRODUCT_EXCLUSION_UPDATED',
        PRODUCT_DELETED = 'PRODUCT_DELETED',
        SNAP_OFFER_MATCHING_DELETED = 'SNAP_OFFER_MATCHING_DELETED',
    }


}

